import { render } from "./AssignLicenseModal.vue?vue&type=template&id=67821ffc&scoped=true"
import script from "./AssignLicenseModal.vue?vue&type=script&lang=js"
export * from "./AssignLicenseModal.vue?vue&type=script&lang=js"

import "./AssignLicenseModal.vue?vue&type=style&index=0&id=67821ffc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Mudassir\\Retrocausal\\portal_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67821ffc"]])

export default __exports__